export class PelletizingEnergyCost {
    constructor({
          id= null, 
          planCode= ``, 
          day= ``,
          locName= ``,          
          shift='',
          energyName= ``,
          energyCode= ``,         
          energyCost= ``,
          unit= ``,
          
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;     
      this.shift = shift;  
      this.energyName = energyName;
      this.energyCode = energyCode;
      this.energyCost = energyCost;
      this.unit = unit;     
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          } 
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },                 
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        },                       
        {
          key: 'energyName',
          label: 'lbl.basic.energyName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'energyCode',
          label: 'lbl.basic.energyCode',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'energyCost',
          label: 'lbl.prd.execution.energyCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'unit',
          label: 'lbl.basic.unit',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new PelletizingEnergyCost()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter', 
    'filter.energyFilter',     
  ];
  export const filter = {
    'planCodeFilter': "", 
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'energyFilter': "",
  };